/** Stable option id from display label (used across all filter dropdowns). */
export function toFilterId(label) {
  return label.
  toLowerCase().
  replace(/&/g, "and").
  replace(/[^a-z0-9]+/g, "-").
  replace(/^-+|-+$/g, "");
}